<template>
  <BaseLayout>
    <div class="page-single position-relative">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col
            cols="10"
            md="8"
            lg="7"
            xl="5"
          >
            <div
              class="d-flex align-items-center justify-content-center"
            >
              <b-card>
                <b-card-title
                  style="font-size: 28px;"
                >
                  Verify your email address
                </b-card-title>
                <b-card-text>
                  To log in and access all the features of our platform, you need to verify your account.
                  <br>Please check the inbox of <b>{{ user.email }}</b> for our verification email.
                </b-card-text>
              </b-card>
            </div>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
        <div
          class="header-brand d-flex justify-content-center mb-5 mr-0 smartology-logo-footer"
          style="z-index: 0;"
        >
          <a
            target="_blank"
            href="https://www.smartology.net/"
          >
            <img
              src="/images/logo.png"
              class="h-7 header-brand-img mr-0"
              alt="Smartology"
            >
          </a>
        </div>
      </b-container>
    </div>
  </BaseLayout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('authentication', {
      user: 'user',
    }),
  },
  created() {
    const {
      redirect,
    } = this.$route.query;

    if (!this.user?.email) {
      if (redirect) {
        this.$router.push(`/login?redirect=${redirect}`);
      } else {
        this.$router.push('/login');
      }
    }
  },
};
</script>
